import { useEffect, useRef, useState } from 'react';
import './App.css';
import heroShadow from './IMG_7615-cutout.png';

const contactLinks = [
  { label: 'Email', value: 'kanishkaprabasara@gmail.com', href: 'mailto:kanishkaprabasara@gmail.com' },
  { label: 'LinkedIn', value: 'kanishka-kumarasiri', href: 'https://www.linkedin.com/in/kanishka-kumarasiri' },
];

const stats = [
  { value: '4+', label: 'Years in data engineering' },
  { value: '10+', label: 'Enterprise initiatives' },
  { value: '9+', label: 'Professional certifications' },
];

const expertise = [
  {
    title: 'Programming & Data Engineering',
    items: ['SQL', 'Python', 'PySpark', 'ETL/ELT', 'Data transformation', 'Pipeline optimization'],
  },
  {
    title: 'Azure Data Platform',
    items: ['Microsoft Fabric', 'Azure Databricks', 'Azure Synapse Analytics', 'Azure Data Factory'],
  },
  {
    title: 'Databases & Platforms',
    items: ['Oracle', 'MySQL', 'SQLite', 'PostgreSQL', 'Databricks', 'Oracle Data Integrator'],
  },
  {
    title: 'Architecture & Orchestration',
    items: ['Data lakehouse', 'Data warehousing', 'Data modeling', 'Metadata-driven pipelines', 'Data lineage'],
  },
  {
    title: 'Governance & Quality',
    items: ['Data governance', 'Data quality', 'Data observability', 'Monitoring', 'Completeness checks'],
  },
  {
    title: 'Tools & Collaboration',
    items: ['Docker', 'SSIS', 'Apache Superset', 'Apache Airflow', 'Git', 'Team collaboration'],
  },
];

const experience = [
  {
    company: 'NeoVizta PVT LTD',
    period: '2026 - Present',
    role: 'Senior Engineer - Data Engineering & AI',
    highlights: [
      'Implemented, monitored, and debugged data flows for the XXXX on-premise data warehouse project.',
      'Built an internal RAG system for a Security Operations Center to support faster knowledge retrieval.',
      'Delivered a compliance-focused RAG system for medical sources for XXXX in Australia.',
    ],
  },
  {
    company: 'Millennium IT ESP',
    period: '2022 - 2026',
    role: 'Engineer - Data Engineering & Analytics',
    highlights: [
      'Delivered enterprise data lake solutions for XXXX, XXXX, and XXXX.',
      'Migrated Oracle reports to Oracle Analytics Cloud for XXXX to improve reporting efficiency.',
      'Designed dashboards and managed data warehouse solutions for XXXX using Apache Superset and Docker.',
      'Ensured performance and reliability for the XXXX data warehouse.',
      'Implemented data visualization and analytics for the XXXX government project using Apache Superset.',
    ],
  },
  {
    company: 'Millennium IT ESP',
    period: '2022 - 2026',
    role: 'Associate Engineer - Data Engineering & Analytics',
    highlights: [
      'Built and maintained Azure Synapse pipelines for XXXX.',
      'Migrated Azure Synapse workloads to Microsoft Fabric while preserving transition continuity and data consistency.',
      'Designed audit data pipelines for XXXX and supported data lake development for XXXX.',
      'Implemented data warehousing and visualization solutions for XXXX Card Center and Savings.',
      'Designed wireframes for XXXX data capture solutions.',
    ],
  },
];

const renderWithTooltip = (text) => {
  if (!text.includes('XXXX')) return text;
  const parts = text.split(/(XXXX)/);
  return (
    <>
      {parts.map((part, index) =>
        part === 'XXXX' ? (
          <span key={index} data-tooltip="Contact me for the exact details" className="redacted-tooltip" style={{ cursor: 'help', borderBottom: '1px dotted currentColor' }}>
            XXXX
          </span>
        ) : (
          part
        )
      )}
    </>
  );
};

const projects = [
  {
    title: 'Enterprise AI & RAG Systems',
    description:
      'Developed internal and compliance-focused RAG systems for security operations and medical-source intelligence, turning domain knowledge into searchable AI workflows.',
    tags: ['RAG', 'AI Engineering', 'Knowledge Retrieval'],
  },
  {
    title: 'Data Warehousing',
    description:
      'Implemented, monitored, and debugged on-premise data warehouse data flows, improving operational visibility and reliability.',
    tags: ['Data Warehouse', 'Monitoring', 'Data Flows'],
  },
  {
    title: 'Azure Data Lake Platforms',
    description:
      'Delivered enterprise data lake solutions for aviation, consumer brands, and pharmaceutical businesses, enabling cleaner analytics and stronger decision-making.',
    tags: ['Azure Data Lake', 'Synapse', 'Enterprise Analytics'],
  },
  {
    title: 'Microsoft Fabric Migration',
    description:
      'Migrated Azure Synapse workloads to Microsoft Fabric with a focus on smooth transition planning, data consistency, and platform modernization.',
    tags: ['Microsoft Fabric', 'Azure Synapse', 'Migration'],
  },
  {
    title: 'BI & Analytics Dashboards',
    description:
      'Designed dashboards and analytics platforms for banking and government programs using Apache Superset, Docker, and governed data warehouse foundations.',
    tags: ['Apache Superset', 'Docker', 'BI'],
  },
  {
    title: 'Oracle Reporting Modernization',
    description:
      'Migrated Oracle reports to Oracle Analytics Cloud for Singapore company, improving reporting efficiency and modernizing analytics delivery.',
    tags: ['Oracle Analytics Cloud', 'Reporting', 'Modernization'],
  },
];

const education = [
  {
    status: 'Reading',
    degree: 'MSc in Computer Science',
    detail: 'Specialization in Cloud Computing',
    institution: 'University of Moratuwa, Sri Lanka',
    current: true,
  },
  {
    status: '2021 - 2024',
    degree: 'BSc (Hons) in Information Technology',
    detail: 'Specialization in Data Science',
    institution: 'Sri Lanka Institute of Information Technology (SLIIT)',
    current: false,
  },
];

const certifications = [
  'Microsoft Certified: Fabric Data Engineer Associate (DP-700) - 2025',
  'Oracle AI Vector Search Certified Professional - 2025',
  'Microsoft Certified: Fabric Analytics Engineer Associate (DP-600) - 2024',
  'Meta Front-End Developer Specialization - 2024',
  'Oracle Cloud Data Management Foundations Associate - 2023',
  'Oracle Cloud Infrastructure Foundations Associate - 2023',
  'IBM DataOps Methodology - 2024',
  'Red Hat Enterprise Linux Fundamentals - 2024',
  'DeepLearning.AI Supervised Machine Learning',
];

const achievements = [
  'MIT Bravo Recognition Award - 2024',
  'Finalist, SLIIT Extreme Hackathon Top 10 - 2021',
  'Participant, APAN56 Datathon - 2023',
  'Oriental Music Visharada in Violin, qualified for Sangeeth Nipun',
  'Project Chairperson, Project Doratuwa - LEO Club of SLIIT, 2023',
];

function usePortfolioScroll() {
  const portfolioRef = useRef(null);
  const [activeStage, setActiveStage] = useState('hero');

  useEffect(() => {
    const root = portfolioRef.current;
    if (!root || typeof window === 'undefined') return undefined;

    const raf = window.requestAnimationFrame || ((callback) => window.setTimeout(callback, 16));
    const cancelRaf = window.cancelAnimationFrame || window.clearTimeout;
    let frameId = null;

    const setScrollVars = () => {
      const doc = document.documentElement;
      const maxScroll = Math.max(1, doc.scrollHeight - window.innerHeight);
      const progress = Math.min(1, Math.max(0, window.scrollY / maxScroll));

      root.style.setProperty('--scroll-progress', progress.toFixed(4));
      root.style.setProperty('--scroll-shift', `${Math.round(progress * -220)}px`);
      root.style.setProperty('--counter-shift', `${Math.round(progress * 150)}px`);
      root.style.setProperty('--portrait-shift', `${Math.round(progress * 96)}px`);
      root.style.setProperty('--ambient-rotate', `${(progress * 28).toFixed(2)}deg`);
      frameId = null;
    };

    const requestScrollVars = () => {
      if (frameId === null) {
        frameId = raf(setScrollVars);
      }
    };

    setScrollVars();
    window.addEventListener('scroll', requestScrollVars, { passive: true });
    window.addEventListener('resize', requestScrollVars);

    const motionQuery =
      typeof window.matchMedia === 'function'
        ? window.matchMedia('(prefers-reduced-motion: reduce)')
        : { matches: false };

    const revealElements = Array.from(root.querySelectorAll('.reveal-on-scroll'));
    let revealObserver;

    if (motionQuery.matches || !('IntersectionObserver' in window)) {
      revealElements.forEach((element) => element.classList.add('is-visible'));
    } else {
      revealObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              revealObserver.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -12% 0px', threshold: 0.14 }
      );

      revealElements.forEach((element) => revealObserver.observe(element));
    }

    const stageElements = Array.from(root.querySelectorAll('[data-stage]'));
    let stageObserver;

    if ('IntersectionObserver' in window) {
      stageObserver = new IntersectionObserver(
        (entries) => {
          const current = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

          if (current?.target?.dataset.stage) {
            setActiveStage(current.target.dataset.stage);
          }
        },
        { rootMargin: '-32% 0px -42% 0px', threshold: [0.16, 0.34, 0.58, 0.82] }
      );

      stageElements.forEach((element) => stageObserver.observe(element));
    }

    return () => {
      window.removeEventListener('scroll', requestScrollVars);
      window.removeEventListener('resize', requestScrollVars);
      if (frameId !== null) cancelRaf(frameId);
      revealObserver?.disconnect();
      stageObserver?.disconnect();
    };
  }, []);

  return { activeStage, portfolioRef };
}

function App() {
  const { activeStage, portfolioRef } = usePortfolioScroll();

  return (
    <div className={`portfolio stage-${activeStage}`} ref={portfolioRef}>
      <div className="scroll-progress" aria-hidden="true" />
      <div className="ambient-stage" aria-hidden="true">
        <span className="ambient-grid" />
        <img src={heroShadow} alt="" className="ambient-portrait" />
      </div>

      <header className="hero" data-stage="hero">
        <nav className="nav-bar" aria-label="Primary navigation">
          <a href="#expertise">Expertise</a>
          <a href="#experience">Experience</a>
          <a href="#projects">Projects</a>
          <a href="#contact">Contact</a>
        </nav>

        <div className="hero-grid">
          <div className="hero-copy reveal-on-scroll reveal-left">
            <p className="eyebrow">Senior Data Engineer</p>
            <h1>Kanishka Kumarasiri</h1>
            <p className="location">Data Engineering & AI | Sri Lanka</p>
            <p className="subtitle">
              I design enterprise-grade data platforms, modern analytics pipelines, and AI-assisted
              knowledge systems across aviation, banking, healthcare, manufacturing, and public-sector domains.
            </p>
            <div className="actions">
              <a href="#projects" className="button">View Work</a>
              <a href="#contact">Contact</a>
            </div>
          </div>
        </div>

        <div className="stat-strip reveal-on-scroll" aria-label="Career statistics" style={{ '--reveal-delay': '220ms' }}>
          {stats.map((item, index) => (
            <div className="stat reveal-on-scroll" key={item.label} style={{ '--reveal-delay': `${280 + index * 80}ms` }}>
              <strong>{item.value}</strong>
              <span>{item.label}</span>
            </div>
          ))}
        </div>
      </header>

      <main>
        <section id="about" className="panel intro-panel reveal-on-scroll reveal-panel" data-stage="profile">
          <div>
            <p className="section-kicker">Profile</p>
            <h2>Enterprise data engineering with an AI-forward mindset.</h2>
          </div>
          <p>
            I am a proactive Data Engineer with hands-on experience delivering scalable software,
            data, and analytics solutions for distributed global teams. My work centers on clean
            architecture, reliable automation, observable pipelines, and data products that improve
            service delivery, asset management, and digital transformation.
          </p>
        </section>

        <section id="expertise" className="panel" data-stage="systems">
          <div className="section-heading">
            <p className="section-kicker">Capabilities</p>
            <h2>Area of Expertise</h2>
          </div>
          <div className="expertise-grid">
            {expertise.map((group, index) => (
              <article className="glass-card reveal-on-scroll" key={group.title} style={{ '--reveal-delay': `${index * 55}ms` }}>
                <h3>{group.title}</h3>
                <div className="chip-list">
                  {group.items.map((item) => (
                    <span key={item}>{item}</span>
                  ))}
                </div>
              </article>
            ))}
          </div>
        </section>

        <section id="experience" className="panel" data-stage="timeline">
          <div className="section-heading">
            <p className="section-kicker">Career Timeline</p>
            <h2>Professional Experience</h2>
          </div>
          <div className="timeline">
            {experience.map((item, index) => (
              <article
                className={`timeline-item reveal-on-scroll ${index % 2 === 0 ? 'reveal-left' : 'reveal-right'}`}
                key={index}
                style={{ '--reveal-delay': `${index * 90}ms` }}
              >
                <div className="timeline-meta">
                  <span>{item.period}</span>
                </div>
                <div className="timeline-content">
                  <h3>{item.role}</h3>
                  <p>{renderWithTooltip(item.company)}</p>
                  <ul>
                    {item.highlights.map((highlight, hIndex) => (
                      <li key={hIndex}>{renderWithTooltip(highlight)}</li>
                    ))}
                  </ul>
                </div>
              </article>
            ))}
          </div>
        </section>

        <section id="projects" className="panel" data-stage="impact">
          <div className="section-heading">
            <p className="section-kicker">Selected Work</p>
            <h2>Technical Projects</h2>
          </div>
          <div className="project-grid">
            {projects.map((project, index) => (
              <article className="project-card reveal-on-scroll" key={project.title} style={{ '--reveal-delay': `${index * 65}ms` }}>
                <h3>{project.title}</h3>
                <p>{project.description}</p>
                <div className="chip-list" aria-label={`${project.title} technologies`}>
                  {project.tags.map((tag) => (
                    <span key={tag}>{tag}</span>
                  ))}
                </div>
              </article>
            ))}
          </div>
        </section>

        <section id="education" className="panel" data-stage="credentials">
          <div className="section-heading">
            <p className="section-kicker">Academic Foundation</p>
            <h2>Education</h2>
          </div>
          <div className="education-list">
            {education.map((item, index) => (
              <article
                className={`education-item reveal-on-scroll ${item.current ? 'current' : ''}`}
                key={item.degree}
                style={{ '--reveal-delay': `${index * 90}ms` }}
              >
                <p className="status">{item.status}</p>
                <h3>{item.degree}</h3>
                <p>{item.detail}</p>
                <p>{item.institution}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="panel split-panel" data-stage="credentials">
          <div className="credential-column reveal-on-scroll reveal-left">
            <div className="section-heading">
              <p className="section-kicker">Credentials</p>
              <h2>Certifications</h2>
            </div>
            <ul className="dense-list">
              {certifications.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
          <div className="credential-column reveal-on-scroll reveal-right" style={{ '--reveal-delay': '120ms' }}>
            <div className="section-heading">
              <p className="section-kicker">Recognition</p>
              <h2>Achievements</h2>
            </div>
            <ul className="dense-list">
              {achievements.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        </section>
      </main>

      <footer id="contact" className="footer reveal-on-scroll reveal-panel" data-stage="contact">
        <div>
          <p className="section-kicker">Contact</p>
          <h2>Let's build reliable data products.</h2>
          <p>Open to enterprise data engineering, analytics modernization, and AI-driven platform work.</p>
        </div>
        <div className="contact-grid">
          {contactLinks.map((link) => (
            <a href={link.href} key={link.label}>
              <span>{link.label}</span>
              <strong>{link.value}</strong>
            </a>
          ))}
        </div>
      </footer>
    </div>
  );
}

export default App;
